export type Lang = "fr" | "en";

export const translations = {
  fr: {
    lang: { fr: "FR", en: "EN" },
    nav: {
      home: "Accueil",
      about: "À propos",
      faculties: "Facultés",
      centers: "Centres",
      articles: "Actualités",
      events: "Événements",
      activities: "Activités",
      schedules: "Horaires",
      tenders: "Appels d'offres",
      planningMenu: "Horaires & infos",
      contact: "Contact",
      login: "Connexion",
      admin: "Admin",
      faq: "FAQ",
      search: "Rechercher",
      searchPlaceholder: "Rechercher sur le site…",
    },
    faculty: {
      title: "Nos Facultés",
      subtitle: "Découvrez l'ensemble des facultés de l'ULPGL-Goma, chacune offrant des programmes d'excellence.",
      presentation: "Présentation",
      programs: "Nos filières",
      news: "Actualités de la faculté",
      direction: "Direction",
      dean: "Doyen",
      secretary: "Secrétaire facultaire",
      domain: "Domaine",
      allFaculties: "Toutes les facultés",
      notFound: "Faculté introuvable",
      noPrograms: "Aucune filière disponible.",
      duration: "Durée",
      diploma: "Diplôme",
      publications: "Publications",
      onlineCourses: "Cours en ligne",
      programsCount: "filière(s)",
      specialPrograms: "Programmes spéciaux",
      specialProgramsLead: "Programmes spéciaux de la faculté : événements et programmes de cours.",
      events: "Événements",
      courses: "Programmes de cours",
    },
    specialProgram: {
      notFound: "Programme introuvable",
      eyebrowPresentation: "Présentation",
      eyebrowPublications: "Publications",
      eyebrowCourses: "Formation",
      eyebrowEvents: "Événements",
      noContent: "Aucune publication pour ce programme pour le moment.",
      info: "Informations",
      contentCount: "Contenus publiés",
      backToFaculty: "Retour à la faculté",
      viewDetails: "Voir les détails →",
    },
    admin: {
      dashboard: "Tableau de bord",
      overview: "Vue d'ensemble",
      articles: "Articles",
      events: "Événements",
      activities: "Activités",
      schedules: "Horaires",
      centers: "Centres",
      faculties: "Facultés",
      faqs: "FAQ",
      pending: "À valider",
      newsletter: "Newsletter",
      messages: "Messages",
      users: "Utilisateurs",
      logout: "Déconnexion",
      viewSite: "Voir le site",
      superAdmin: "Super Admin",
      publisher: "Publieur",
      newFaculty: "Nouvelle faculté",
      editFaculty: "Modifier la faculté",
      newUser: "Nouvel utilisateur",
      editUser: "Modifier l'utilisateur",
      createUser: "Créer un utilisateur",
      french: "Français",
      english: "English",
      pageContent: "Contenu de la page (affiché sur le site)",
      coverImage: "Image de couverture",
      programs: "Filières",
      addProgram: "Ajouter une filière",
      save: "Enregistrer",
      create: "Créer",
      cancel: "Annuler",
      delete: "Supprimer",
      edit: "Modifier",
      active: "Actif",
      inactive: "Inactif",
      roleAdmin: "Super administrateur",
      rolePublisher: "Publieur faculté",
      roleCenterPublisher: "Publieur centre",
      selectCenter: "— Sélectionner un centre —",
      galleryImages: "Images supplémentaires (jusqu'à 4)",
      galleryImage: "Image",
      deanManual: "Nom du doyen (si hors liste)",
      secretaryManual: "Nom du secrétariat (si hors liste)",
      mediaAttachment: "Média principal (vidéo ou PDF)",
      mediaAttachmentHelp: "YouTube, lien vidéo (MP4, Vimeo) ou PDF — affiché avec prévisualisation intégrée sur la page.",
      mediaType: "Type de média",
      mediaNone: "— Aucun —",
      mediaVideoLink: "Lien vidéo",
      mediaLayout: "Format d'affichage",
      mediaLayoutAuto: "Automatique (selon le fichier)",
      mediaLayoutPortrait: "Portrait (affiche / poche)",
      mediaLayoutLandscape: "Paysage (bannière)",
      mediaUrl: "URL",
      mediaPdfUpload: "Document PDF",
      mediaPreview: "Aperçu",
      passwordOptional: "Nouveau mot de passe (laisser vide pour ne pas changer)",
      passwordRequired: "Mot de passe (min. 6 caractères)",
      noFaculty: "Aucune faculté.",
      noUsers: "Aucun utilisateur.",
      confirmDeleteFaculty: "Supprimer cette faculté et toutes ses filières ?",
      confirmDeleteUser: "Supprimer cet utilisateur ?",
      newFaq: "Nouvelle question",
      editFaq: "Modifier la question",
      faqQuestion: "Question (FR)",
      faqQuestionEn: "Question (EN)",
      faqAnswer: "Réponse (FR)",
      faqAnswerEn: "Réponse (EN)",
      faqOrder: "Ordre d'affichage",
      noFaqs: "Aucune question.",
      confirmDeleteFaq: "Supprimer cette question ?",
      keyFacts: "Chiffres clés",
      newKeyFact: "Nouveau fait clé",
      editKeyFact: "Modifier le fait clé",
      keyFactTitle: "Titre (FR)",
      keyFactTitleEn: "Titre (EN)",
      keyFactValue: "Valeur",
      keyFactOrder: "Ordre d'affichage",
      noKeyFacts: "Aucun fait clé.",
      confirmDeleteKeyFact: "Supprimer ce fait clé ?",
      sitePartners: "Partenaires",
      newPartner: "Nouveau partenaire",
      editPartner: "Modifier le partenaire",
      noPartners: "Aucun partenaire.",
      confirmDeletePartner: "Supprimer ce partenaire ?",
      admissionGuide: "Guide d'inscription",
      admissionGuideTitle: "Titre de la page",
      admissionGuideYear: "Année académique",
      admissionGuideIntro: "Introduction",
      admissionGuideContent: "Contenu du guide",
      admissionGuideContact: "Téléphones de contact",
      admissionGuideSaved: "Guide d'inscription enregistré",
      admissionGuideDesc: "Ce contenu est affiché publiquement sur la page \"Guide d'inscription\" du site.",
      academicFees: "Frais académiques",
      academicFeesDesc: "Modifiez la grille des frais affichée sur la page \"Frais académiques\". Le total de chaque ligne est recalculé automatiquement comme la somme de ses frais.",
      academicFeesSaved: "Grille des frais enregistrée",
      academicFeesPromotion: "Promotion",
      academicFeesFaculty: "Faculté",
      academicFeesTotal: "Total",
      academicFeesAddRow: "Ajouter une ligne",
      academicFeesDeleteRow: "Supprimer la ligne",
      academicFeesEmpty: "Aucune ligne de frais.",
      academicFeesTotalHint: "Le total est la somme des frais de la ligne.",
      name: "Nom",
      email: "Email",
      role: "Rôle",
      faculty: "Faculté",
      selectFaculty: "— Sélectionner une faculté —",
      siteDashboard: "Admin site dashboard",
      sectionAcademic: "Académique",
      sectionResearch: "Recherche & centres",
      sectionWeb: "Contenu web",
      sectionAdmin: "Administration",
      domains: "Domaines",
      programsNav: "Filières",
      staff: "Personnel",
      researchCenters: "Centres de recherche",
      articlesPosts: "Articles (Posts)",
      categories: "Catégories",
      activitiesEvents: "Activités / Événements",
      academicYear: "Année académique",
      overviewEyebrow: "Vue d'ensemble",
      overviewWelcome: "Bonjour, voici l'état du contenu publié.",
      overviewDesc: "Retrouvez en un coup d'œil les statistiques de votre site et les dernières publications.",
      recentEyebrow: "Derniers contenus",
      recentTitle: "Publications récentes",
      recentEmpty: "Aucune publication pour l'instant. Créez votre premier article dans la section Articles.",
      statArticles: "Articles (Posts)",
      statStaff: "Personnel",
      statCenters: "Centres de recherche",
      statDomains: "Domaines",
      statFaculties: "Facultés",
      statPrograms: "Filières",
      statActivities: "Activités / Événements",
      statFaqs: "FAQs",
      statCategories: "Catégories",
      statKeyFigures: "Chiffres clés",
      statVisitors: "Visiteurs (total)",
      visits: "Statistiques de visites",
      visitsSubtitle: "Fréquentation du site : visites totales, uniques et tendance sur 7 jours.",
      visitsTotal: "Visites totales",
      visitsUnique: "Visiteurs uniques",
      visitsToday: "Visites aujourd'hui",
      visitsTodayUnique: "Uniques aujourd'hui",
      visitsLast7Days: "7 derniers jours",
      visitsTopPages: "Pages les plus visitées",
      visitsNoData: "Aucune donnée de visite pour le moment.",
      loginHistory: "Historique de connexion",
      loginHistorySubtitle: "Tentatives de connexion des utilisateurs (24 dernières heures).",
      loginHistoryEmpty: "Aucune connexion enregistrée pour le moment.",
      loginStatusSuccess: "Réussie",
      loginStatusFailed: "Échouée",
      loginStatusDisabled: "Compte désactivé",
      loginColUser: "Utilisateur",
      loginColStatus: "Statut",
      loginColIp: "Adresse IP",
      loginColDevice: "Appareil",
      loginColDate: "Date",
      colPath: "Page",
      colVisits: "Visites",
      schedulesFull: "Horaires (cours & examens)",
      newSchedule: "Nouvel horaire",
      newCenter: "Nouveau centre",
      emptyContent: "Aucun contenu publié pour le moment.",
      emptySchedules: "Aucun horaire publié pour le moment.",
      emptyCenters: "Aucun centre de recherche pour le moment.",
      emptyPending: "Tout est à jour, rien à valider.",
      emptyNewsletter: "Aucun abonné newsletter pour le moment.",
      emptyMessages: "Aucun message de contact pour le moment.",
      emptyUsers: "Aucun utilisateur enregistré pour le moment.",
      publish: "Publier",
      submitForReview: "Soumettre",
      published: "Publié",
      submitted: "Soumis pour validation",
      contentTitle: "Titre",
      excerpt: "Résumé court",
      contentBody: "Contenu",
      category: "Catégorie",
      eventDate: "Date de l'événement",
      location: "Lieu",
      editSchedule: "Modifier l'horaire",
      editCenter: "Modifier le centre",
      scheduleSubtitle: "Planification des cours et examens",
      scheduleType: "Type",
      scheduleCourses: "Horaire des cours",
      scheduleExams: "Horaire des examens",
      promotion: "Promotion",
      programOptional: "Filière (optionnel)",
      allPrograms: "— Toutes les filières —",
      semester: "Semestre",
      startDate: "Début",
      endDate: "Fin",
      description: "Description",
      scheduleFile: "Document / image (PDF ou image)",
      scheduleFileOptional: "Document complémentaire (PDF ou image, optionnel)",
      scheduleDisplayMode: "Mode d'affichage",
      scheduleModeGrid: "Tableau hebdomadaire (grille)",
      scheduleModeDocument: "Document uniquement (PDF / image)",
      scheduleNotes: "Notes complémentaires",
      scheduleNotesPlaceholder: "Informations additionnelles affichées sous le tableau…",
      tenders: "Appels d'offres",
      newTender: "Nouvel appel d'offres",
      editTender: "Modifier l'appel d'offres",
      tenderSubtitle: "Avis et dossiers de consultation publique",
      tenderDeadline: "Date limite de dépôt",
      tenderDocument: "Dossier PDF / image",
      emptyTenders: "Aucun appel d'offres publié.",
      centerName: "Nom du centre",
      shortDescription: "Description courte",
      coverImageOptional: "Image de couverture (optionnelle)",
      direction: "Direction",
      directorName: "Nom du directeur",
      directorRole: "Rôle (ex: Directeur)",
      directorEmails: "Email(s) séparés par ,",
      directorPhones: "Téléphone(s) séparés par ,",
      oneLinePerEntry: "Saisissez chaque entrée sur une nouvelle ligne ↓",
      interventionAreas: "Domaines d'intervention",
      completedStudies: "Études réalisées",
      partners: "Partenaires",
      contacts: "Contacts",
      detailedProfile: "Profil détaillé (HTML)",
      centerProfilePlaceholder: "Présentation longue du centre...",
      dean: "Doyen",
      secretary: "Secrétaire",
      facultyContentPlaceholder: "Rédigez la présentation complète de la faculté…",
      facultyContentPlaceholderEn: "Write the full faculty presentation…",
      userFormSubtitle: "Gérez les accès et permissions du compte",
      categoryPlaceholder: "Choisir ou saisir une catégorie…",
      newStaff: "Nouveau membre",
      editStaff: "Modifier le membre",
      staffSubtitle: "Corps professoral, administratif et comité de gestion",
      staffImage: "Photo",
      staffIsOrganizer: "Membre du comité de gestion (gouvernance)",
      staffEmails: "Email(s)",
      staffPhones: "Téléphone(s)",
      staffOnePerLine: "Une entrée par ligne",
      staffBibliography: "Bibliographie / présentation",
      staffResearchInterests: "Domaines de recherche",
      staffPublications: "Publications",
      staffCv: "Lien CV (URL)",
      staffOrganizerBadge: "Comité",
      emptyStaff: "Aucun membre du personnel pour le moment.",
      confirmDeleteStaff: "Supprimer ce membre du personnel ?",
      specialPrograms: "Programmes spéciaux",
      specialProgramsSubtitle: "Programmes spéciaux des facultés (événements, cours)",
      newSpecialProgram: "Nouveau programme",
      specialProgramName: "Nom du programme",
      specialProgramActive: "Programme actif (visible sur le site)",
      emptySpecialPrograms: "Aucun programme spécial pour le moment.",
      confirmDeleteSpecialProgram: "Supprimer ce programme spécial ?",
      specialProgram: "Programme spécial",
      selectSpecialProgram: "— Aucun programme —",
      selectStaffMember: "— Sélectionner un membre —",
      status: "Statut",
      refresh: "Actualiser",
      broadcastTitle: "Diffuser la publication",
      broadcastSubtitle: "Envoyer un e-mail aux abonnés de la newsletter",
      broadcastSend: "Envoyer la diffusion",
      broadcastSending: "Envoi en cours…",
      broadcastSent: "Diffusion envoyée avec succès",
      broadcastRecipients: "Destinataires",
      broadcastAll: "Tous les abonnés",
      broadcastSelect: "Sélectionner",
      broadcastSelectDesc: "Choisir les destinataires",
      broadcastSubscribers: "abonné(s)",
      broadcastSelected: "sélectionné(s)",
      broadcastSelectAll: "Tout sélectionner",
      broadcastDeselectAll: "Tout désélectionner",
      broadcastNoRecipients: "Aucun destinataire sélectionné",
      broadcastAllConfirm: "L'e-mail sera envoyé à tous les abonnés.",
    },
    common: {
      loading: "Chargement…",
      saveSuccess: "Enregistré avec succès",
      error: "Erreur",
      required: "Champs obligatoires manquants",
    },
    login: {
      welcome: "BIENVENUE",
      title: "Connectez-vous à votre espace administrateur",
      subtitle: "Utilisez vos identifiants institutionnels pour accéder au tableau de bord.",
      password: "Mot de passe",
      submit: "Se connecter",
      submitting: "Connexion…",
      forgotPassword: "Mot de passe oublié",
      forgotHelp: "En cas d'oubli de mot de passe, veuillez passer par la DNTIC pour une assistance.",
      heroTitle: "Gestion du contenu du site",
      heroAccent: "en toute sérénité.",
      heroDesc: "Administration centralisée du contenu du site web.",
    },
  },
  en: {
    lang: { fr: "FR", en: "EN" },
    nav: {
      home: "Home",
      about: "About",
      faculties: "Faculties",
      centers: "Centers",
      articles: "News",
      events: "Events",
      activities: "Activities",
      schedules: "Schedules",
      tenders: "Calls for tenders",
      planningMenu: "Schedules & info",
      contact: "Contact",
      login: "Login",
      admin: "Admin",
      faq: "FAQ",
      search: "Search",
      searchPlaceholder: "Search the website…",
    },
    faculty: {
      title: "Our Faculties",
      subtitle: "Discover all ULPGL-Goma faculties, each offering excellent academic programs.",
      presentation: "Overview",
      programs: "Our programs",
      news: "Faculty news",
      direction: "Leadership",
      dean: "Dean",
      secretary: "Secretary",
      domain: "Field",
      allFaculties: "All faculties",
      notFound: "Faculty not found",
      noPrograms: "No programs available.",
      duration: "Duration",
      diploma: "Degree",
      publications: "Publications",
      onlineCourses: "Online courses",
      programsCount: "program(s)",
      specialPrograms: "Special programs",
      specialProgramsLead: "Faculty special programs: events and course programs.",
      events: "Events",
      courses: "Course programs",
    },
    specialProgram: {
      notFound: "Program not found",
      eyebrowPresentation: "Overview",
      eyebrowPublications: "Publications",
      eyebrowCourses: "Courses",
      eyebrowEvents: "Events",
      noContent: "No publications for this program yet.",
      info: "Information",
      contentCount: "Published content",
      backToFaculty: "Back to faculty",
      viewDetails: "View details →",
    },
    admin: {
      dashboard: "Dashboard",
      overview: "Overview",
      articles: "Articles",
      events: "Events",
      activities: "Activities",
      schedules: "Schedules",
      centers: "Centers",
      faculties: "Faculties",
      faqs: "FAQ",
      pending: "Pending approval",
      newsletter: "Newsletter",
      messages: "Messages",
      users: "Users",
      logout: "Log out",
      viewSite: "View website",
      superAdmin: "Super Admin",
      publisher: "Publisher",
      refresh: "Refresh",
      newFaculty: "New faculty",
      editFaculty: "Edit faculty",
      newUser: "New user",
      editUser: "Edit user",
      createUser: "Create user",
      french: "Français",
      english: "English",
      pageContent: "Page content (displayed on the website)",
      coverImage: "Cover image",
      programs: "Programs",
      addProgram: "Add program",
      save: "Save",
      create: "Create",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      active: "Active",
      inactive: "Inactive",
      roleAdmin: "Super administrator",
      rolePublisher: "Faculty publisher",
      roleCenterPublisher: "Center publisher",
      selectCenter: "— Select a center —",
      galleryImages: "Additional images (up to 4)",
      galleryImage: "Image",
      deanManual: "Dean name (if not in list)",
      secretaryManual: "Secretary name (if not in list)",
      mediaAttachment: "Main media (video or PDF)",
      mediaAttachmentHelp: "YouTube, video link (MP4, Vimeo) or PDF — shown with an embedded preview on the page.",
      mediaType: "Media type",
      mediaNone: "— None —",
      mediaVideoLink: "Video link",
      mediaLayout: "Display format",
      mediaLayoutAuto: "Automatic (based on file)",
      mediaLayoutPortrait: "Portrait (poster / flyer)",
      mediaLayoutLandscape: "Landscape (banner)",
      mediaUrl: "URL",
      mediaPdfUpload: "PDF document",
      mediaPreview: "Preview",
      passwordOptional: "New password (leave blank to keep current)",
      passwordRequired: "Password (min. 6 characters)",
      noFaculty: "No faculties yet.",
      noUsers: "No users yet.",
      confirmDeleteFaculty: "Delete this faculty and all its programs?",
      confirmDeleteUser: "Delete this user?",
      newFaq: "New question",
      editFaq: "Edit question",
      faqQuestion: "Question (FR)",
      faqQuestionEn: "Question (EN)",
      faqAnswer: "Answer (FR)",
      faqAnswerEn: "Answer (EN)",
      faqOrder: "Display order",
      noFaqs: "No questions yet.",
      confirmDeleteFaq: "Delete this question?",
      keyFacts: "Key facts",
      newKeyFact: "New key fact",
      editKeyFact: "Edit key fact",
      keyFactTitle: "Title (FR)",
      keyFactTitleEn: "Title (EN)",
      keyFactValue: "Value",
      keyFactOrder: "Display order",
      noKeyFacts: "No key facts yet.",
      confirmDeleteKeyFact: "Delete this key fact?",
      sitePartners: "Partners",
      newPartner: "New partner",
      editPartner: "Edit partner",
      noPartners: "No partners yet.",
      confirmDeletePartner: "Delete this partner?",
      admissionGuide: "Admission guide",
      admissionGuideTitle: "Page title",
      admissionGuideYear: "Academic year",
      admissionGuideIntro: "Introduction",
      admissionGuideContent: "Guide content",
      admissionGuideContact: "Contact phone numbers",
      admissionGuideSaved: "Admission guide saved",
      admissionGuideDesc: "This content is shown publicly on the site's \"Admission guide\" page.",
      academicFees: "Academic fees",
      academicFeesDesc: "Edit the fees grid shown on the \"Academic fees\" page. Each row total is automatically calculated as the sum of its fees.",
      academicFeesSaved: "Fees grid saved",
      academicFeesPromotion: "Promotion",
      academicFeesFaculty: "Faculty",
      academicFeesTotal: "Total",
      academicFeesAddRow: "Add row",
      academicFeesDeleteRow: "Delete row",
      academicFeesEmpty: "No fee rows yet.",
      academicFeesTotalHint: "The total is the sum of fees in the row.",
      name: "Name",
      email: "Email",
      role: "Role",
      faculty: "Faculty",
      selectFaculty: "— Select a faculty —",
      siteDashboard: "Admin site dashboard",
      sectionAcademic: "Academic",
      sectionResearch: "Research & centers",
      sectionWeb: "Web content",
      sectionAdmin: "Administration",
      domains: "Domains",
      programsNav: "Programs",
      staff: "Staff",
      researchCenters: "Research centers",
      articlesPosts: "Articles (Posts)",
      categories: "Categories",
      activitiesEvents: "Activities / Events",
      academicYear: "Academic year",
      overviewEyebrow: "Overview",
      overviewWelcome: "Hello, here is the status of published content.",
      overviewDesc: "See your site statistics and latest publications at a glance.",
      recentEyebrow: "Latest content",
      recentTitle: "Recent publications",
      recentEmpty: "No publications yet. Create your first article in the Articles section.",
      statArticles: "Articles (Posts)",
      statStaff: "Staff",
      statCenters: "Research centers",
      statDomains: "Domains",
      statFaculties: "Faculties",
      statPrograms: "Programs",
      statActivities: "Activities / Events",
      statFaqs: "FAQs",
      statCategories: "Categories",
      statKeyFigures: "Key figures",
      statVisitors: "Visitors (total)",
      visits: "Visit statistics",
      visitsSubtitle: "Site traffic: total visits, unique visitors and 7-day trend.",
      visitsTotal: "Total visits",
      visitsUnique: "Unique visitors",
      visitsToday: "Visits today",
      visitsTodayUnique: "Unique today",
      visitsLast7Days: "Last 7 days",
      visitsTopPages: "Most visited pages",
      visitsNoData: "No visit data yet.",
      loginHistory: "Login history",
      loginHistorySubtitle: "User login attempts (last 24 hours).",
      loginHistoryEmpty: "No login recorded yet.",
      loginStatusSuccess: "Success",
      loginStatusFailed: "Failed",
      loginStatusDisabled: "Account disabled",
      loginColUser: "User",
      loginColStatus: "Status",
      loginColIp: "IP address",
      loginColDevice: "Device",
      loginColDate: "Date",
      colPath: "Page",
      colVisits: "Visits",
      schedulesFull: "Schedules (courses & exams)",
      newSchedule: "New schedule",
      newCenter: "New center",
      emptyContent: "No content published yet.",
      emptySchedules: "No schedules published yet.",
      emptyCenters: "No research centers yet.",
      emptyPending: "Everything is up to date.",
      emptyNewsletter: "No newsletter subscribers yet.",
      emptyMessages: "No contact messages yet.",
      emptyUsers: "No users registered yet.",
      publish: "Publish",
      submitForReview: "Submit",
      published: "Published",
      submitted: "Submitted for review",
      contentTitle: "Title",
      excerpt: "Short summary",
      contentBody: "Content",
      category: "Category",
      eventDate: "Event date",
      location: "Location",
      editSchedule: "Edit schedule",
      editCenter: "Edit center",
      scheduleSubtitle: "Course and exam scheduling",
      scheduleType: "Type",
      scheduleCourses: "Course schedule",
      scheduleExams: "Exam schedule",
      promotion: "Year level",
      programOptional: "Program (optional)",
      allPrograms: "— All programs —",
      semester: "Semester",
      startDate: "Start",
      endDate: "End",
      description: "Description",
      scheduleFile: "Document / image (PDF or image)",
      scheduleFileOptional: "Supplementary document (PDF or image, optional)",
      scheduleDisplayMode: "Display mode",
      scheduleModeGrid: "Weekly timetable (grid)",
      scheduleModeDocument: "Document only (PDF / image)",
      scheduleNotes: "Additional notes",
      scheduleNotesPlaceholder: "Extra information shown below the grid…",
      tenders: "Calls for tenders",
      newTender: "New call for tenders",
      editTender: "Edit call for tenders",
      tenderSubtitle: "Public procurement notices and documents",
      tenderDeadline: "Submission deadline",
      tenderDocument: "PDF / image document",
      emptyTenders: "No calls for tenders published yet.",
      centerName: "Center name",
      shortDescription: "Short description",
      coverImageOptional: "Cover image (optional)",
      direction: "Leadership",
      directorName: "Director name",
      directorRole: "Role (e.g. Director)",
      directorEmails: "Email(s) separated by ,",
      directorPhones: "Phone(s) separated by ,",
      oneLinePerEntry: "Enter each item on a new line ↓",
      interventionAreas: "Areas of intervention",
      completedStudies: "Completed studies",
      partners: "Partners",
      contacts: "Contacts",
      detailedProfile: "Detailed profile (HTML)",
      centerProfilePlaceholder: "Long center presentation...",
      dean: "Dean",
      secretary: "Secretary",
      facultyContentPlaceholder: "Write the full faculty presentation…",
      facultyContentPlaceholderEn: "Write the full faculty presentation…",
      userFormSubtitle: "Manage account access and permissions",
      categoryPlaceholder: "Pick or type a category…",
      newStaff: "New member",
      editStaff: "Edit member",
      staffSubtitle: "Faculty, administrative staff and management committee",
      staffImage: "Photo",
      staffIsOrganizer: "Management committee member (governance)",
      staffEmails: "Email(s)",
      staffPhones: "Phone(s)",
      staffOnePerLine: "One entry per line",
      staffBibliography: "Biography / presentation",
      staffResearchInterests: "Research interests",
      staffPublications: "Publications",
      staffCv: "CV link (URL)",
      staffOrganizerBadge: "Committee",
      emptyStaff: "No staff members yet.",
      confirmDeleteStaff: "Delete this staff member?",
      specialPrograms: "Special programs",
      specialProgramsSubtitle: "Faculty special programs (events, courses)",
      newSpecialProgram: "New program",
      specialProgramName: "Program name",
      specialProgramActive: "Active program (visible on the site)",
      emptySpecialPrograms: "No special programs yet.",
      confirmDeleteSpecialProgram: "Delete this special program?",
      specialProgram: "Special program",
      selectSpecialProgram: "— No program —",
      selectStaffMember: "— Select a member —",
      status: "Status",
      broadcastTitle: "Broadcast publication",
      broadcastSubtitle: "Send an email to newsletter subscribers",
      broadcastSend: "Send broadcast",
      broadcastSending: "Sending…",
      broadcastSent: "Broadcast sent successfully",
      broadcastRecipients: "Recipients",
      broadcastAll: "All subscribers",
      broadcastSelect: "Select",
      broadcastSelectDesc: "Choose recipients",
      broadcastSubscribers: "subscriber(s)",
      broadcastSelected: "selected",
      broadcastSelectAll: "Select all",
      broadcastDeselectAll: "Deselect all",
      broadcastNoRecipients: "No recipients selected",
      broadcastAllConfirm: "The email will be sent to all subscribers.",
    },
    common: {
      loading: "Loading…",
      saveSuccess: "Saved successfully",
      error: "Error",
      required: "Required fields are missing",
    },
    login: {
      welcome: "WELCOME",
      title: "Log in to your administrator space",
      subtitle: "Use your institutional credentials to access the dashboard.",
      password: "Password",
      submit: "Log in",
      submitting: "Logging in…",
      forgotPassword: "Forgotten password",
      forgotHelp: "If you forgot your password, please contact DNTIC for assistance.",
      heroTitle: "Manage your site content",
      heroAccent: "with peace of mind.",
      heroDesc: "Centralized administration of the website content.",
    },
  },
} as const;

export type TranslationKey = typeof translations.fr | typeof translations.en;
